import { createSelector } from 'reselect';
import getQueryParamOverride from '@gameday/utils/getQueryParamOverride';

const useContentApiOverride = getQueryParamOverride('useContentApi');

const getIsLoading = (state) => state?.loading?.isLoading;
const getDeviceInteraction = (state) => state?.config?.deviceInteraction ?? {};
const getLanguage = (state) => state?.config?.language ?? {};
const getAppPath = (state) => state?.config?.appPath ?? '';
const getDataViz = (state) => {
    return (
        (useContentApiOverride ?? state.config?.useContentApi)
            ? state?.content?.highlightsByTypes?.dataViz
            : state?.contentGraph?.highlightsByTypes?.dataViz
    ) ?? [];
};

export const getDataVizState = createSelector(
    [getDataViz, getDeviceInteraction, getLanguage, getIsLoading, getAppPath],
    (dataViz, deviceInteraction, language, isLoading, appPath) => {
        return {
            dataViz,
            deviceInteraction,
            isLoading,
            language,
            appPath
        };
    }
);
